import { UserRequest } from "../types";

const api = process.env.REACT_APP_API;

export const createUser = async (
  accessToken: string,
  userInfo: UserRequest,
) => {
  try {
    const userResponse = await fetch(`${api}/user/create`, {
      method: "POST",
      body: JSON.stringify({ ...userInfo }),
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-type": "application/json",
      },
    });

    return await userResponse.json();
  } catch (err) {
    throw new Error(`Failed to create user`);
  }
};

export const deleteUser = async (accessToken: string) => {
  try {
    const userResponse = await fetch(`${api}/user/remove`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-type": "application/json",
      },
    });

    return await userResponse.json();
  } catch (err) {
    throw new Error(`Failed to delete user`);
  }
};

export const updateUserCurrency = async (
  accessToken: string,
  updatedSub: Object,
) => {
  try {
    const currencyResponse = await fetch(`${api}/user/currency`, {
      method: "PUT",
      body: JSON.stringify({ ...updatedSub }),
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-type": "application/json",
      },
    });

    return await currencyResponse.json();
  } catch (err) {
    throw new Error(`Failed to update user sub`);
  }
};
